import React from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import { Provider } from 'mobx-react';

import CustomerComponent from './customer_components';
import LocaleStore from './common_components/localization/LocaleStore';
import igroadmapsLocales from '../locales/igroadmap.json';

export default class Customers extends React.Component {
  localeStore = null;

  constructor(props) {
    super(props);

    this.localeStore = new LocaleStore(props.userLocale, [igroadmapsLocales]);
  }

  render() {
    return (
      <Provider
        isPremium={this.props.isPremium}
      >
        <IntlProvider
          locale={this.localeStore.locale}
          messages={this.localeStore.messages}
        >
          <BrowserRouter>
            <Route
              render={props => <CustomerComponent {...props} {...this.props} />}
            />
          </BrowserRouter>
        </IntlProvider>
      </Provider>
    );
  }
}
